<template>
    <div>
        <button class="btn btn-sm text-light" type="button"
        data-toggle="modal"
        @click="click(data)"
        data-target="#group-access" v-tooltip="{ content: 'Update access', placement: 'top', triggers: 'hover' }">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16" style="fill: #000000;">
                <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"></path>
                <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"></path>
            </svg>
        </button>
    </div>
</template>

<script >
export default {
    props: {
        data: {},
        name: {},
        click: {
            type: Function,
            default: () => {
            }
        }
    }

}
</script>

<style lang="scss" scoped>
    button {
        border: none;
        background: none;
        outline: 0;

        svg {
            width: 18px;
            height: 18px;
            color: #3490dc;
        }
    }
</style>
